import { useIntl } from 'react-intl';
import { useSetAtom } from 'jotai';
import { openSnackbarAdviseAtom } from '../Atoms';

// Returns `notify(messageKey, severity)` and `notifyError(messageKey, err?)` snackbar openers.
export default function useNotify() {
  const intl = useIntl();
  const setSnackbar = useSetAtom(openSnackbarAdviseAtom);

  const notify = (messageKey, severity) =>
    setSnackbar({ message: intl.messages[messageKey], severity });

  const notifyError = (messageKey, err) =>
    setSnackbar({
      message: `${intl.messages.ERROR}: ${
        err?.status ? `${err?.status} - ` : ''
      } ${intl.messages[messageKey]}`,
      severity: 'error',
    });

  return { notify, notifyError };
}
